<template>
	<LabeledFieldLayout
		:hint="hint"
		class="labeled-confidence-level-drop-down"
	>
		<template v-slot:hint v-if="$slots.hint">
			<slot name="hint">{{ hint }}</slot>
		</template>
		<ConfidenceLevelMenu
			:value="value"
			:disabled="disabled"
			@change="onChange"
		/>
	</LabeledFieldLayout>
</template>

<script>
import LabeledFieldLayout from "./LabeledFieldLayout";
import ConfidenceLevelMenu from "../ConfidenceLevelMenu";

export default {
	name: "LabeledConfidenceLevelDropDown",
	emits: [
		"change",
	],
	components: {
		ConfidenceLevelMenu,
		LabeledFieldLayout,
	},
	props: {
		hint: {
			type: String,
			default: "",
		},
		value: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		onChange( option ) {
			this.$emit( "change", option );
		},
	},
};
</script>

<style lang="scss" scoped>
.labeled-confidence-level-drop-down {
	.teaming-drop-down {
		width: 100%;
	}
}
</style>
